import React from 'react'
import ReactDOM from 'react-dom'
import Loadable from 'react-loadable'
import * as serviceWorker from 'serviceWorker'
import App from './App'
import {HelmetProvider} from "react-helmet-async";
import {initDeviceSession} from 'helpers/deviceSession'

// Không await — không chặn render, request đầu tiên tự retry qua 419 nếu chưa kịp xong
initDeviceSession()

function render() {
  const renderMethod = window.__SERVER_STATE__
    ? // $FlowIssue
      ReactDOM.hydrate
    : ReactDOM.render

  return renderMethod(
      <HelmetProvider>
          <App />
      </HelmetProvider>,
    document.getElementById('root')
  )
}

Loadable.preloadReady()
  .then(render)
  .catch(err => {
    console.error(err)
  })

serviceWorker.unregister()
